module.exports = __webpack_public_path__ + "img/face-smile-hearts.d734bc3b.svg";